export const AUTH_RETURN_PATH = "auth-return-path";
export const TENANT = "tenant";
export const LOCATION = "location";
export const INSTALLABLE_PROMPT_COUNT = "installable-prompt-count";
